// Russian UI translations
export const ru = {
    // Common
    common: {
        save: "Сохранить",
        cancel: "Отмена",
        finish: "Закончить",
        delete: "Удалить",
        edit: "Редактировать",
        add: "Добавить",
        remove: "Удалить",
        close: "Закрыть",
        apply: "Применить",
        search: "Поиск",
        filter: "Фильтр",
        period: "Период",
        loading: "Загрузка...",
        saving: "Сохранение...",
        error: "Ошибка",
        success: "Успешно",
        confirm: "Подтвердить",
        yes: "Да",
        no: "Нет",
        ok: "ОК",
        back: "Назад",
        backToHome: "Вернуться на главную",
        next: "Далее",
        previous: "Назад",
        select: "Выбрать",
        all: "Все",
        none: "Нет",
        settings: "Настройки",
        options: "Параметры",
        actions: "Действия",
        status: "Статус",
        date: "Дата",
        amount: "Сумма",
        companyName: "Название компании",
        currency: "Валюта",
        description: "Описание",
        name: "Название",
        total: "Итого",
        duplicate: "Дублировать",
        shareLink: "Поделиться ссылкой",
        selected: "выбрано",
        showing: "Показано",
        of: "из",
        noInvoicesFound: "Счета-фактуры не найдены",
        noExpensesFound: "Расходы не найдены",
        tryChangingQuery: "Попробуйте изменить запрос поиска",
        startByCreating: "",
        createFirstInvoice: "Создать первый счёт-фактуру",
        createFirstExpense: "Добавить первый расход",
        language: "Язык",
        logout: "Выйти",
        create: "Создать",
        home: "Главная",
        optional: "Необязательно",
    },

    // Transfer Invoices
    transferInvoices: {
        title: "ПЕРЕНОС СЧЕТОВ С ДРУГОГО СЕРВИСА",
        menuLabel: "ПЕРЕНОС СЧЕТОВ",
        description: "Мы с радостью поможем вам перенести ваши счета из любой другой системы за последний налоговый период. Мы сделаем это бесплатно в течение 3 рабочих дней (максимум 50 счетов за 1 год).",
        aiTransferTitle: "Если не хотите ждать, вы можете попробовать перенести данные с ваших счетов-фактур самостоятельно.",
        aiTransferDescription: "Для этого скопируйте инструкции для своего ИИ-чата (мы рекомендуем использовать ChatGPT) с помощью кнопки {button} и скопированным текстом из своих счетов. Полученный ответ вставьте в форму ниже и нажмите кнопку Создать фактуры автоматически.",
        setupRequired: "Для этого заполните форму ниже:",
        prefilledText: "Здравствуйте, я хотел/а бы перенести следующие счета:",
        storageLink: "Ссылка на хранилище файлов (например, Google Drive)",
        storageLinkPlaceholder: "Убедитесь, что ссылка доступна для всех пользователей",
        emailNote: "Если вы хотите послать файлы через имейл, напишите нам на почту {email}",
        submit: "Отправить запрос",
        manualSubmitButton: "Отправить запрос вручную",
        autoSubmitButton: "Создать фактуры автоматически",
        jsonDataLabel: "Данные для автоматического создания (JSON формат)",
        jsonDataPlaceholder: "Вставьте ваш JSON здесь для автоматической обработки...",
        jsonDataHelp: "Если у вас есть данные в нашем формате JSON, вы можете вставить их здесь для автоматического создания счетов.",
        success: "Запрос отправлен! Мы свяжемся с вами в ближайшее время.",
        autoSuccess: "{count} фактур создано автоматически!",
        specificationButton: "Спецификация",
        copyLlmButton: "Инструкция для LLM",
        llmInstructionsTitle: "Инструкция скопирована!",
        llmInstructionsDescription: "Теперь вы можете вставить этот промпт в вашу LLM (ChatGPT, Claude и др.) для конвертации данных.",
        specificationTitle: "Спецификация JSON",
    },
    expenses: {
        title: "Расходы",
        addExpense: "Добавить расход",
        editExpense: "Редактировать расход",
        expenseName: "Название / Поставщик",
        category: "Категория",
        date: "Дата",
        amount: "Сумма",
        currency: "Валюта",
        note: "Заметка",
        manageTitle: "Управление расходами",
        deleteConfirm: "Вы уверены, что хотите удалить этот расход?",
        validationMessage: "Пожалуйста, введите название и сумму",
        categories: {
            subscriptions: "Подписки и сервисы",
            consulting: "Консультация",
            communication: "Связь",
            education: "Образование",
            equipment: "Оборудование",
            marketing: "Реклама",
            rent: "Офис / Аренда",
            software: "ПО / SaaS",
            supplies: "Расходные материалы",
            travel: "Командировки",
            salary: "Зарплаты",
            taxes: "Налоги",
            other: "Прочее"
        }
    },
    // Support
    support: {
        miniLabel: "Не хватает функциональности? Что-то не работает? Есть вопросы?",
        button: "ПОДДЕРЖКА",
        modalTitle: "Техническая поддержка",
        modalSubtitle: "Мы работаем 7 дней в неделю.",
        modalEmailLabel: "Напишите на имейл",
        modalNote: "Напишите с имейла, на который вы зарегистрировали ваш аккаунт.",
    },

    // Invoice App
    invoice: {
        invoiceGenerator: "Генератор счетов-фактур",
        invoiceBasics: "Основные данные",
        parties: "Стороны",
        subtotal: "Подитог",
        grandTotal: "Итого",
        save: "Сохранить",
        saving: "Сохранение...",
        saved: "Сохранено",
        notSaved: "Не сохранено",
        invoiceNumber: "Номер счёта-фактуры",
        issueDate: "Дата выставления",
        dueDate: "Дата оплаты",
        customer: "Клиент",
        address: "Адрес",
        buyerId: "ID покупателя",
        loadDefaults: "Настроить данные по умолчанию",
        sellerInfo: "Информация о продавце",
        country: "Страна",
        notes: "Примечания",
        identificationNumber: "IČO (налоговый номер)",
        dic: "DIČ (номер плательщика НДС)",
        czechSoleProprietor: "Я — частный предприниматель (OSVČ) в Чехии",
        czechSoleProprietorTooltip: "Добавляет обязательную юридическую информацию в счёт-фактуру",
        paymentInfo: "Платежная информация",
        items: "Позиции",
        addItem: "Добавить позицию",
        pricePerUnit: "Цена за единицу",
        note: "Примечание",
        downloadPdf: "Скачать PDF",
        print: "Печать (диалог)",
        sendByEmail: "Отправить по имейл",
        saveInvoiceFirst: "Сначала сохраните фактуру",
        newInvoice: "Новый счёт-фактура",
        invoiceNumberRequired: "Введите номер фактуры, чтобы сохранить или скачать",
        invoiceNumberEmpty: "Номер фактуры обязателен",
        comingInFebruary: "Появится в феврале, ждите обновлений!",
        printNote: "При печати через диалог снимите галочку 'Заголовки'. Кнопка 'Скачать PDF' автоматически удаляет всё лишнее.",
        daysUntilDue: "Дней до оплаты",
        dueDateSettings: "Настройки даты оплаты",
        dueDateExplanation: "Установите количество дней по умолчанию для даты оплаты. Это будет применяться к новым счетам-фактурам.",
        invoiceLanguage: "Язык счёта-фактуры",
        invoiceNumberTemplate: "Шаблон номера счёта-фактуры",
        invoiceNumberTemplateTooltip: "Настройки шаблона номера счёта-фактуры",
        paymentOptions: "Варианты оплаты",
        addPaymentOption: "Добавить вариант оплаты",
        paymentType: "Тип оплаты",
        paymentTitle: "Название",
        paymentDetails: "Детали",
        bankTransfer: "Банковский перевод",
        onlinePayment: "Онлайн оплата",
        cash: "Наличные",
        custom: "Другое",
        paymentUponDelivery: "Оплата при доставке или самовывозе",
        enterCustomPaymentDetails: "Введите детали оплаты",
        paymentMethodBankingDetails: "Способ оплаты и банковские реквизиты",
        removePaymentOption: "Удалить",
        businessLogo: "Логотип компании",
        uploadLogo: "Загрузить логотип",
        removeLogo: "Удалить логотип",
        website: "Веб-сайт",
        websiteText: "Текст веб-сайта",
        issuedBy: "Выдано",
        acceptedBy: "Принято",
        signature: "Подпись",
        uploadSignature: "Загрузить подпись",
        removeSignature: "Удалить подпись",
        vatPayer: "Плательщик НДС",
        nonVatPayer: "Неплательщик НДС",
        notSpecified: "Не указано",
        taxSettings: "Настройки налогов",
        enableVat: "Включить НДС",
        vatRate: "Ставка НДС (%)",
        vat: "НДС",
        netAmount: "Сумма без НДС",
        vatAmount: "Сумма НДС",
        totalAmount: "Итоговая сумма",
        discount: "Скидка",
        quantity: "Кол-во",
        price: "Цена",
        unit: "Единица",
        discountPercent: "Скидка (%)",
        applyDiscount: "Применить скидку",
        itemDiscount: "Скидка на позицию",
        totalDiscount: "Общая скидка",
        addCustomTax: "Добавить налог",
        taxName: "Название налога",
        taxAmount: "Сумма налога",
        taxPercentage: "Процент налога",
        fixedAmount: "Фиксированная сумма",
        percentage: "Процент",
        czechMarket: "Для чешского рынка",
        internationalMarket: "Для международного рынка",
        accountNumber: "Номер счета",
        bankName: "Название банка",
        bankAddress: "Адрес банка",
        variableSymbol: "Переменный символ",
        constantSymbol: "Постоянный символ",
        specificSymbol: "Специфический символ",
        paymentLink: "Платежная ссылка",
        paymentUrl: "URL платежа",
        linkText: "Текст ссылки",
        account: "Счет",
        bank: "Банк",
        showQRCode: "Показать QR-код (действительно только для чешских банков!)",
        invoiceStatus: "Статус счёта-фактуры",
        status: "Статус",
        managePaymentMethods: "Управление способами оплаты",
        manageClients: "Управление сохраненными клиентами",
        manageSavedItems: "Управление сохраненными позициями",
        templateButton: "Шаблон",
        manageButton: "Управлять",
        savedPaymentMethods: "Сохраненные методы оплаты",
        selectPaymentMethod: "Выбрать метод оплаты",
        addSaved: "Добавить сохраненный",
        descriptionPlaceholder: "Описание услуги / товара",
        unitPlaceholder: "шт",
        units: {
            pcs: "шт.",
            hours: "часы",
            days: "дни",
            months: "мес.",
            kg: "кг",
            unit: "ед",
            liters: "литры",
            m: "м",
            m2: "м²",
            m3: "м³",
        },
        noSavedMethods: "Сохраненные способы оплаты не найдены",
        selectSavedPaymentMethod: "Выбрать сохраненный способ оплаты",
        useExistingPaymentInfo: "Используйте существующую платежную информацию для автоматического создания вариантов оплаты или добавьте их вручную.",
        autoPopulate: "Автозаполнение из существующих данных",
        saveAsTemplate: "Сохранить эту конфигурацию как шаблон",
        onboarding: {
            startTitle: "Как выставлять счета в Invoitio? Научитесь за 2 минуты.",
            startButton: "Начать обучение",
            skipButton: "Пропустить",
            tutorialButton: "Обучение",
            trainingLocation: "Обучение всегда находится здесь. Если не будете понимать, как сделать что-то, активируйте его на любой странице!",
            steps: {
                basics: {
                    title: "Основные данные",
                    description: "Здесь вы можете выбрать язык, и дату оплаты счета, а также изменить его номер.",
                },
                template: {
                    title: "Шаблоны",
                    description: "Здесь можно настроить шаблон автоматической нумерации ваших счетов.",
                },
                dueDate: {
                    title: "Срок оплаты",
                    description: "Вы можете настроить срок оплаты через поле с датой или через количество дней, нажав на кнопку с настройками.",
                },
                parties: {
                    title: "Стороны",
                    description: "Заполните данные продавца и клиента. Переключайтесь между ними с помощью вкладок.",
                },
                manageClients: {
                    title: "Управление клиентами",
                    description: "Сохраняйте данные клиентов здесь, чтобы выбирать их одним кликом в будущем.",
                },
                items: {
                    title: "Позиции",
                    description: "Добавьте услуги или товары. Сумма и налоги рассчитаются автоматически.",
                },
                payment: {
                    title: "Методы оплаты",
                    description: "Выберите способы оплаты. Их можно сохранить как шаблоны для быстрой вставки.",
                },
                status: {
                    title: "Статус оплаты",
                    description: "Отслеживайте жизненный цикл платежа. Статус «Просрочено» обновляется автоматически для счетов в статусе «Ожидается», если они не помечены как оплаченные. Вы также можете настроить автоматические уведомления клиентов в меню «Уведомления клиентам».",
                },
                save: {
                    title: "Сохранить счёт",
                    description: "Обязательно нажимайте кнопку Сохранить, если хотите сохранить данные в счёте-фактуре!",
                },
                final: {
                    title: "Самое важное!",
                    description: "Для того, чтобы ваш счет-фактура соответствовал формальным требованиям в Чешской республике, заполните ВСЕ поля, касающиеся легальной информации в секциях: Клиент, Информация о продавце, хотя бы 1 метод оплаты, и хотя бы один товар или услугу.",
                    button: "Понятно!"
                }
            }
        },
        validation: {
            modalTitle: "Неполный счёт-фактура",
            modalMessage: "В счёте-фактуре не заполнены обязательные поля: {fields}. Вы уверены, что хотите сохранить счет в таком виде?",
            modalMessageDownload: "В счёте-фактуре не заполнены обязательные поля: {fields}. Вы уверены, что хотите скачать счет?",
            fixButton: "Исправить",
            continueButton: "Продолжить",
            downloadButton: "Скачать",
            okButton: "Сохранить",
            errorRequired: "Это поле обязательно для заполнения",
            errorRequiredWarning: "Заполните, если клиент не является физическим лицом, в противном случае это поле не является обязательным",
            sectionError: "Пожалуйста, заполните обязательные поля в этой секции",
            aresButton: "Автозаполнение данных компании из Чехии (ARES)",
            aresLoading: "Загрузка...",
            aresNotFound: "Компания не найдена",
            aresError: "Ошибка при получении данных",
            aresMinChars: "Введите минимум 8 символов",
            fields: {
                invoiceNo: "Номер счёта-фактуры",
                issueDate: "Дата выставления",
                dueDate: "Дата оплаты",
                sellerName: "Название продавца",
                sellerTaxId: "IČO (налоговый номер) продавца",
                sellerVatNumber: "DIČ (номер плательщика НДС) продавца",
                sellerAddress: "Адрес продавца",
                buyerName: "Название клиента",
                buyerTaxId: "IČO (налоговый номер) клиента",
                buyerVatNumber: "DIČ (номер плательщика НДС) клиента",
                buyerAddress: "Адрес клиента",
                buyerEmail: "Email клиента",
                sellerEmail: "Email продавца",
                items: "Позиции (добавьте хотя бы одну)",
                itemsValid: "Описание и цена в каждой позиции",
                paymentOptions: "Метод оплаты (выберите хотя бы один)",
                paymentBank: "Реквизиты банка (номер счета или IBAN)",
                paymentLink: "Ссылка на оплату",
                paymentCustom: "Описание метода оплаты",
            }
        },
    },

    // Invoice List
    invoiceList: {
        title: "Список счетов-фактур",
        newInvoice: "Новый счёт-фактура",
        searchPlaceholder: "Поиск счетов-фактур...",
        noInvoices: "Счета-фактуры не найдены",
        columns: {
            invoiceNumber: "Номер",
            client: "Клиент",
            description: "Описание",
            amount: "Сумма",
            issueDate: "Дата выставления",
            dueDate: "Дата оплаты",
            status: "Статус",
            actions: "Действия",
        },
        invoiceStatus: "Статус оплаты счета:",
        status: {
            paid: "Оплачено",
            pending: "Ожидается",
            overdue: "Просрочено",
        },
        actions: {
            edit: "Редактировать",
            delete: "Удалить",
            download: "Скачать",
            downloadPdf: "Скачать PDF",
            archive: "Архивировать",
            changeStatus: "Изменить статус",
        },
        deleteModal: {
            title: "Удалить счёт-фактуру",
            message: "Вы уверены, что хотите удалить этот счёт-фактуру? Это действие необратимо.",
            messageMultiple: "Вы уверены, что хотите удалить {count} выбранных счетов-фактур? Это действие необратимо.",
            confirm: "Удалить",
            cancel: "Отмена",
        },
        settings: {
            title: "Настройки счетов-фактур по умолчанию",
            configureMyData: "НАСТРОИТЬ МОИ ДАННЫЕ ДЛЯ ФАКТУР",
            sellerModalTitle: "Данные продавца по умолчанию",
            sellerName: "Название",
            sellerTaxId: "IČO (налоговый номер)",
            sellerVatNumber: "DIČ (номер плательщика НДС)",
            sellerWebsite: "Веб-сайт",
            sellerAddress: "Адрес",
            sellerIsCzechSoleProprietor: "Я — частный предприниматель (OSVČ) в Чехии",
            sellerIsVatPayer: "Плательщик НДС",
            sellerNotes: "Примечания",
            vatNotSpecified: "Не указано",
            vatPayer: "Плательщик",
            vatNotPayer: "Не плательщик",
            defaultDueDays: "Дней до оплаты по умолчанию",
            defaultDueDaysDescription: "Количество дней до срока оплаты",
            defaultTemplate: "Шаблон по умолчанию",
            invoiceStyle: "Стиль счёта-фактуры",
            defaultCurrency: "Валюта по умолчанию",
            defaultLanguage: "Язык по умолчанию",
            invoiceNumberTemplate: "Шаблон номера счёта-фактуры",
            save: "Сохранить",
            cancel: "Отмена",
            saved: "Настройки сохранены успешно",
            saving: "Сохранение...",
        },
        onboarding: {
            startTitle: "Научитесь управлять и настраивать счета за 2 минуты",
            startButton: "Начать обучение",
            skipButton: "Пропустить",
            trainingLocation: "Обучение всегда находится здесь. Если не будете понимать, как сделать что-то, активируйте его на любой странице!",
            tutorialButton: "ОБУЧЕНИЕ",
            steps: {
                table: {
                    title: "Список счетов",
                    description: "Здесь находится таблица, в которой отображаются все ваши созданные счета-фактуры.",
                },
                actions: {
                    title: "Действия со счётом",
                    description: "В этом столбце вы можете скачать счёт, поделиться защищенной ссылкой, отправить напоминание по e-mail, дублировать или удалить счёт.",
                },
                bulk: {
                    title: "Групповые действия",
                    description: "Выделив несколько счетов, вы можете их массово дублировать, удалить, скачать архивом или экспортировать в Excel.",
                },
                settings: {
                    title: "Настройки по умолчанию",
                    description: "Это очень важная секция! Здесь настраиваются данные, которые будут подставляться во все новые счета: язык, информация о продавце, валюта и шаблон номера.",
                },
                filters: {
                    title: "Фильтры",
                    description: "Используйте фильтры, чтобы быстро найти нужные счета или изменить способ их отображения в списке.",
                },
                newInvoice: {
                    title: "Создание счета",
                    description: "Чтобы создать новый счет-фактуру, просто нажмите эту кнопку!",
                }
            }
        },
        archive: {
            download: "Скачать архив",
            downloading: "Загрузка...",
            archiving: "Архивируем счета-фактуры",
            noSelection: "Выберите счета-фактуры для архивирования",
        },
        errors: {
            statusChangeError: "Ошибка при изменении статуса",
            deleteError: "Ошибка при удалении счёта-фактуры",
            backendDeleteError: "Ошибка при удалении счёта-фактуры из базы данных",
            archiveError: "Ошибка при создании архива",
            backendNotAvailable: "База данных недоступна. Загружен текстовый файл вместо ZIP архива.",
        },
        filter: "Фильтр",
        filterSortBy: "Сортировать по",
        filterSortOrder: "Порядок сортировки",
        filterIssueDate: "По дате выставления",
        filterAmount: "По сумме",
        filterDueDate: "По дате оплаты",
        filterClientName: "По имени клиента",
        filterCreatedAt: "По дате создания",
        filterStatus: "Статус",
        filterStatusSort: "По статусу",
        filterAscending: "По возрастанию",
        filterDescending: "По убыванию",
        filterSelectField: "Выберите поле",
        filterSelectOrder: "Выберите порядок",
        filterReset: "Сбросить",
    },

    // Statistics
    statistics: {
        title: "Статистика",
        totalRevenue: "Общий доход",
        revenueByClient: "Доход по клиентам",
        revenueByCurrency: "Доход по валютам",
        revenueTimeline: "График дохода",
        baseCurrency: "Базовая валюта",
        selectYear: "Выбрать год",
        allYears: "Все годы",
        year: "Год",
        month: "Месяц",
        client: "Клиент",
        revenue: "Доход",
        income: "Приход",
        expense: "Расход",
        totalExpenses: "Общие расходы",
        expensesByCategory: "Категории расходов",
        expensesByCurrency: "Расходы по валютам",
        percentage: "Процент",
        info: "Информация",
        infoTooltip: "Курсы валют загружаются из Европейского центрального банка (ECB) и обновляются в реальном времени для поддерживаемых валют ЕС и других валют.\n\nВ режиме реального времени обновляются следующие валюты:\nEUR, USD, CZK, GBP, ARS, AUD, BGN, BRL, CAD, CHF, CNY, DKK, HKD, HRK, HUF, IDR, ILS, INR, ISK, JPY, KRW, MAD, MXN, MYR, NOK, NZD, PHP, PLN, RON, RUB, SEK, SGD, THB, TRY, TWD, ZAR.\n\nОстальные валюты обновляются раз в месяц. Для конвертации таких валют используется швейцарский франк (CHF) в качестве промежуточной валюты.\n\nCHF также используется как промежуточная валюта при расчёте общего дохода для всех валют, кроме CZK, EUR, USD и GBP, которые конвертируются в реальном времени по курсам ECB.",
        loadingRates: "Загрузка курсов обмена...",
        noData: "Нет данных",
        arpu: {
            label: "Средний доход с пользователя (ARPU)",
            period: "Период",
            formula: "Общий доход ÷ Платящие клиенты",
            formulaLabel: "Формула ARPU:",
            formulaFull: "ARPU = Общий доход ÷ Платящие клиенты (здесь на клиента)",
        },
        mrr: {
            label: "Месячный рекуррентный доход (MRR)",
            formula: "Платящие клиенты × ARPU",
            formulaLabel: "Формула MRR:",
            formulaFull: "MRR = (Общее количество платящих клиентов) × (Средний доход с пользователя)",
        },
        netIncome: "Чистый доход (доходы - расходы)",
        avgMonthlyRevenue: "Среднемесячный доход",
        avgMonthlyExpenses: "Среднемесячный расход",
        includePending: "Учитывать счета-фактуры ждущие оплаты в рассчетах?",
        statusDistribution: "Распределение статусов счетов-фактур",
        period: "Период",
        total: "Всего",
        allTime: "За все время",
        currentMonth: "Текущий месяц",
        previousMonth: "Предыдущий месяц",
        previousYear: "Прошлый год",
        exportToExcel: "Экспорт в Excel",
        exportModal: {
            title: "Экспорт в Excel",
            selectRange: "Выберите временной промежуток",
            from: "ОТ",
            to: "ДО",
            tableLanguage: "Язык таблицы",
            download: "Скачать"
        },
    },

    // Invoice Templates
    invoiceTemplates: {
        title: "Шаблоны фактур",
        comingSoon: "Скоро появится",
        description: "Создавайте и управляйте своими шаблонами счетов, чтобы ускорить рабочий процесс.",
        createTemplate: "Создать шаблон",
    },

    // Repeating Invoices
    repeatingInvoices: {
        title: "Повторяющиеся фактуры",
        step1: "Шаг 1 - выберите фактуру для повторения",
        step2: "Шаг 2 - выберите интервал",
        everyMonthDay: "Я хочу выставлять счет каждый",
        dayOfMonth: "день месяца",
        lastDayNote: "* Если в месяце меньше дней, будет использован последний день месяца",
        or: "— ИЛИ —",
        intervalLabel: "Я хочу выставлять счет-фактуру каждые",
        days: "дней",
        fromDate: "С",
        toDate: "По",
        templateNameLabel: "Название шаблона",
        templateNamePlaceholder: "напр. Ежемесячный счет для Рога и Копыта",
        optional: "(необязательно)",
        createButton: "Создать фактуры",
        managementTitle: "Управление повторяющимися фактурами",
        noTemplates: "У вас пока нет шаблонов повторяющихся фактур.",
        noTemplatesSub: "Выберите счет и настройте параметры повторения выше, чтобы создать свой первый шаблон.",
        deleteConfirm: "Вы уверены, что хотите удалить этот шаблон повторяющихся фактур?",
        successCreated: "Готово! Вы успешно создали {count} фактур",
    },

    // Client Notifications
    clientNotifications: {
        title: "Уведомления клиентам",
        setupNotice: "Перед тем, как начать пользоваться уведомлениями, настройте:",
        setupAlwaysChange: "Вы всегда можете изменить это в Общие настройки -> Адрес имейла для уведомлений клиентам",
        setupRequiredTitle: "Требуется настройка",
        setupRequiredDescription: "Пожалуйста, заполните и сохраните имя отправителя и имейл-хендл выше, чтобы разблокировать разделы напоминаний.",
        manualSection: "Ручная отправка напоминаний",
        manualStep1: "Шаг 1 - Выберите шаблон имейла",
        manualStep2: "Шаг 2 - Выберите фактуру для отправки",
        emailLangLabel: "Язык имейла",
        manualEditNotice: "У вас будет возможность отредактировать имейл перед отправкой в шаге 'Предпросмотр и отправка'",
        autoEditNotice: "У Вас будет возможность отредактировать имейл перед отправкой в шаге 'Предпросмотр и настройка напоминания' ниже.",
        previewAndSend: "Предпросмотр и отправка",
        allInvoices: "Все счета",
        overdueInvoicesOnly: "Просроченные счета",
        overdueInvoices: "Просроченные фактуры",
        reminderSent: "Напоминание успешно отправлено!",
        reminderError: "Не удалось отправить напоминание. Проверьте настройки или адрес почты клиента.",
        noEmailError: "У этого клиента не указан адрес электронной почты.",
        noInvoicesFound: "Счета не найдены.",
        howItWorksTitle: "КАК ЭТО РАБОТАЕТ?",
        howItWorksDescription: "Автоматические напоминания настраиваются глобально для конкретного сохраненного клиента. Чтобы они работали, убедитесь, что при создании новых счетов вы выбираете клиента из списка сохраненных через поле «выберите клиента» и {clientLink} на {appLink}. Если вы хотите отправить напоминание только по одному конкретному счету, воспользуйтесь разделом {manualLink} выше.",
        clientLink: "«Управление сохраненными клиентами»",
        appLink: "странице создания новых счетов",
        manualLink: "«Ручная отправка»",
        autoSection: "Настройка автоматических напоминаний",
        autoStep1: "Шаг 1 - Выберите клиента",
        autoStep2: "Шаг 2 - Конфигурация",
        autoIntervalLabel: "Я хочу отправлять автоматические напоминания клиенту через",
        autoIntervalShort: "Отправка через",
        daysAfterDue: "дней после просроченного платежа",
        emailTemplateLabel: "Шаблон имейла, который я хочу использовать:",
        emailTemplateShort: "Шаблон",
        standardTemplateChoice: "Выберу стандартный шаблон на",
        saveSettings: "Предпросмотр и настройка напоминания",
        sendManual: "Отправить напоминание",
        confirmModalTitle: "Так будет выглядеть имейл для клиента:",
        recipientEmailLabel: "Имейл клиента:",
        sendTo: "отправить на",
        editEmail: "Редактировать имейл",
        save: "Сохранить",
        invoiceDownloaded: "Счет скачан, можете посмотреть на него",
        missingFieldsTitle: "Не хватает следующих данных в счете-фактуре или имейле:",
        missingFieldsNote: "Измените сам {invoiceLink} и текст ниже нажав кнопку 'Редактировать имейл'",
        invoiceLink: "счет-фактуру",
        emailNotConfiguredTitle: "Имейл для отправки не настроен",
        emailNotConfiguredDescription: "Нужно сходить в {link} и настроить свой адрес почты, чтобы иметь возможность отправлять уведомления.",
        notificationsLink: "Уведомления клиентам",
        emailMissingTitle: "Отсутствует адрес электронной почты",
        emailMissingDescription: "У этого клиента не указан адрес электронной почты. Вы должны добавить его в 'Управление сохраненными клиентами', прежде чем сможете настроить автоматические напоминания.",
        noOverdue: "Просроченных счетов не найдено.",
        noInvoicesTitle: "У вас пока нет счетов",
        noInvoicesDescription: "Создайте свой первый счет, чтобы начать пользоваться системой напоминаний для ваших клиентов.",
        createFirstInvoice: "Создать первый счет",
        previewInstructionAuto: "Чтобы посмотреть, как будет выглядеть отправленный имейл, создайте первый счёт и выберите его в этой секции для предпросмотра!",
        previewInstructionManual: "Для предпросмотра выберите счет-фактуру кликом на строку в шаге 2",
        noClients: "Клиентов не найдено.",
        searchInvoices: "Поиск просроченных счетов...",
        searchClients: "Поиск клиентов...",
        placeholderCompany: "Название вашей компании",
        placeholderPayment: "{paymentDetails}",
        customTemplateChoice: "Свой текст",
        manageAutoSection: "Управление авто-напоминаниями",
        reminderFor: "Напоминание для",
        lastSent: "Последняя отправка",
        neverSent: "Никогда",
        activeStatus: "Активно",
        inactiveStatus: "На паузе",
        noAutoReminders: "Автоматические напоминания не настроены.",
        deleteReminderConfirm: "Вы уверены, что хотите прекратить автоматические напоминания для этого клиента?",
        actions: {
            sendReminder: "Отправить напоминание"
        }
    },

    // Client Dialog
    clientDialog: {
        title: "Клиент",
        manageTitle: "Управление клиентами",
        addTitle: "Добавить нового клиента",
        editTitle: "Редактировать клиента",
        name: "Название",
        address: "Адрес",
        email: "Email",
        phone: "Телефон",
        taxId: "Налоговый ID",
        buyerId: "ID покупателя",
        namePlaceholder: "Название клиента",
        addressPlaceholder: "Адрес клиента",
        buyerIdPlaceholder: "ID: 12345678",
        selectClient: "Выберите клиента",
        existingClients: "Существующие клиенты",
        noClients: "Клиенты еще не добавлены.",
        add: "Добавить клиента",
        update: "Обновить клиента",
        save: "Сохранить",
        cancel: "Отмена",
        delete: "Удалить",
        deleteConfirm: "Вы уверены, что хотите удалить этого клиента?",
        validationMessage: "Хотя бы одно поле должно быть заполнено",
    },

    // Payment Method Dialog
    paymentMethodDialog: {
        title: "Способ оплаты",
        manageTitle: "Управление способами оплаты",
        addTitle: "Добавить способ оплаты",
        editTitle: "Редактировать способ оплаты",
        type: "Тип",
        titleLabel: "Название",
        details: "Детали",
        accountNumber: "Номер счета",
        iban: "IBAN",
        bicSwift: "BIC/SWIFT",
        bankName: "Название банка",
        bankAddress: "Адрес банка",
        variableSymbol: "Переменный символ",
        constantSymbol: "Постоянный символ",
        specificSymbol: "Специфический символ",
        paymentUrl: "URL платежа",
        linkText: "Текст ссылки",
        savedMethods: "Сохраненные способы оплаты",
        noMethods: "Способы оплаты еще не сохранены.",
        add: "Добавить способ оплаты",
        update: "Обновить способ оплаты",
        save: "Сохранить",
        cancel: "Отмена",
        delete: "Удалить",
        deleteConfirm: "Вы уверены, что хотите удалить этот способ оплаты?",
        validationMessage: "Название и хотя бы одно другое поле должны быть заполнены",
        bankTransfer: "Банковский перевод",
        paymentLink: "Платежная ссылка",
        cash: "Наличные",
        custom: "Другое",
        titlePlaceholderBank: "Банковский перевод",
        titlePlaceholderLink: "Оплата онлайн",
        titlePlaceholderCash: "Наличные",
        titlePlaceholderCustom: "Другая оплата",
        detailsPlaceholderCash: "Оплата наличными при доставке или самовывозе",
        detailsPlaceholderCustom: "Введите детали оплаты",
    },

    // Landing Page
    landing: {
        hero: {
            title: "Cчёт-фактура за 10 секунд",
            subtitle: "Отправка по имейл и в мессенджеры из приложения, учет расходов и прибыли, оплата по QR. Самый удобный инвойсинг сервис для фрилансеров, стартапов и малого бизнеса в Чешской Республике и Евросоюзе",
            tryButton: "Попробуйте Invoitio бесплатно 30 дней",
            noCardRequired: "💳🚫 Без привязки карты",
            madeInCzech: "Сделано в Чешской республике",
            womenOwned: "Women-owned",
        },
        nav: {
            tryIt: "Попробовать",
            functionality: "Функции",
            pricing: "Цены",
            faq: "FAQ",
            invoiceList: "Блог",
            login: "Вход",
            start: "Начать",
            contact: "Контакты",
        },
        features: {
            title: "Функции",
            voiceInput: "1 предложение вместо бесконечных форм",
            voiceInputDescription: "Вы говорите — Invoitio считает и выставляет счёт. Быстро и без ошибок.",
            reports: "Отчёты о прибыли",
            reportsDescription: "Понятные графики вместо ручных подсчётов — экономьте время бухгалтера.",
            reminders: "Напоминания о просроченных платежах",
            remindersDescription: "Клиент не оплатил услугу вовремя? Invoitio напомнит за вас — вежливо и вовремя.",
            mobile: "Поддержка мобильных устройств",
            mobileDescription: "Интерфейс работает на любом устройстве.",
            storage: "Надёжное хранилище",
            storageDescription: "Все счета-фактуры в одном месте, с быстрым поиском.",
            languages: "Поддержка 5 языков",
            languagesDescription: "Английский, чешский, словацкий, немецкий и русский. Плюс кастомизация полей.",
            modern: {
                unlimited: "Никаких лимитов на счета и количество пользователей",
                analytics: "Один понятный обзор прибыли и расходов с метриками",
                repeating: "Повторяемые фактуры - делайте их в один клик для постоянных клиентов",
                send: "Отправка счёта по e-mail и в мессенджеры",
                multi: "Любая валюта, 5 языков интерфейса и фактур, QR код",
                notSure: "Еще не уверены?",
                fullList: "Полный список функций",
                roadmapTitle: "Будущие функции программы",
            },
            grid: {
                transfer: "Бесплатно перенесём ваши фактуры в наше приложение за последний год. И во время пробного периода!",
                security: "Ваши данные в безопасности. Мы используем шифрование для защиты ваших данных при передаче и при хранении.",
                eu_servers: "🇪🇺 Серверы только в Европейском союзе",
                charts: "Наглядный график доходов и расходов",
                messengers: "Отправка счетов в мессенджеры - WhatsApp, Telegram и любые другие мессенджеры из приложения.",
                ecb_rates: "Курсы валют от Европейского центрального банка в реальном времени",
                excel_export: "Экспорт в Excel, чтобы сдача налоговой отчётности была простой и удобной.",
                expense_tracking: "Учёт расходов",
                password_links: "Счета с паролем по уникальной ссылке.",
                qr_codes: "QR код для оплаты в фактуре для чешских банков",
                website_link: "Ссылка на ваш сайт прямо в фактуре",
                templates: "Шаблоны фактур - сохраняйте свои данные, методы оплаты и легко вставляйте или копируйте их",
            },
            roadmap: {
                feb1: "Автоматическая отправка счетов и автонапоминания о неоплаченных счетах",
                feb1_date: "Февраль 2026",
                feb2: "Time tracking и выставление счетов на основе учёта времени",
                feb2_date: "Февраль 2026",
                mar: "Синхронизация с банками для автоматического определения статуса оплаты",
                mar_date: "Март 2026",
                apr: "Склад — система учёта товаров, связанная с фактурами и движением товаров",
                apr_date: "Апрель 2026",
            },
            detailed: {
                feature1: "5 языков интерфейса и счетов: английский, чешский, словацкий, немецкий и русский.",
                feature2: "Добавляйте любые способы оплаты и ссылки прямо в счёт + QR-оплата.",
                feature3: "Любая валюта.",
                feature4: "Отсылайте счета-фактуры прямо из Invoitio — экономьте время на поиске контактов :)",
                feature3a: "Без ограничений в полной версии: неограниченное количество счетов, клиентов и поставщиков.",
                feature3b: "Единый отчёт о прибыли и расходах в выбранной валюте.",
                feature3c: "Экспорт для бухгалтеров + отдельный доступ для бухгалтера.",
                feature3d: "Соответствие требованиям нескольких юрисдикций.",
                feature5: "Расширенная аналитика доходов: MRR, LTV, ARPU, потоки доходов и многое другое, поддерживающая все валюты.",
            },
        },
        pricing: {
            title: "Цена, которая работает на вас",
            subtitle: "",
            limitedDiscount: "ОГРАНИЧЕННАЯ СКИДКА 15%",
            monthly: "Месячная подписка",
            monthlyPrice: "220 Kč",
            monthlyOldPrice: "253 Kč",
            monthlyPeriod: " / месяц",
            yearlyMainPrice: "133 Kč",
            yearlyOldMainPrice: "153 Kč",
            yearlyMainPeriod: "/ месяц",
            yearlySubscriptionText: "при подписке",
            yearlySubPrice: "1600 Kč в год",
            oneYear: "Годовой доступ",
            oneYearPrice: "1600 Kč",
            oneYearOldPrice: "1840 Kč в год",
            oneYearPeriod: " / год",
            oneYearButton: "Получить Invoitio сейчас",
            trustedBy: "Доверяют 2500+ пользователей",
            lifetime: "Пожизненный доступ",
            lifetimePrice: "3960 Kč",
            lifetimeOldPrice: "4554 Kč",
            lifetimePeriod: " единоразово",
            beneficial: "ЛУЧШЕЕ ПРЕДЛОЖЕНИЕ",
            mostPopular: "ВЫБИРАЮТ ЧАЩЕ ВСЕГО",
            hoursUntilPriceIncrease: "8 часов до повышения цены",
            features: {
                allFeatures: "Все функции Invoitio",
                twoDevices: "2 устройства: вы и бухгалтер",
                support: "Поддержка",
                forever: "Навсегда — без подписок",
                allFuture: "Все текущие и будущие функции",
                priority: "Приоритетная поддержка",
            },
            start: "Начать",
            buy: "Купить",
        },
        faq: {
            title: "Часто задаваемые вопросы",
            subtitle: "Ответы на популярные вопросы о Invoitio",
            question0: "Можно ли перенести счета из другой системы в Invoitio?",
            answer0: "Мы бесплатно перенесём фактуры за ваш текущий налоговый период в нашу систему (даже в течение пробного периода).",
            question1: "Есть ли у вас партнерская программа?",
            answer1: "Да, у нас есть партнерская программа для всех наших пользователей! Вы получаете 30% пожизненной рекуррентной комиссии с рефералов. Если вы заинтересованы в участии в реферальной программе, [зарегистрируйтесь] и перейдите в [настройки], чтобы скопировать реферальную ссылку.",
            question2: "Можно ли использовать Invoitio бесплатно?",
            answer2: "Да! Вы можете попробовать Invoitio бесплатно в течение 30 дней. После этого доступны месячные, годовые и пожизненные тарифы.",
            question5: "Как Invoitio помогает с просроченными платежами?",
            answer5: "(с февраля 2026) Система автоматически отслеживает сроки оплаты и отправляет напоминания клиентам о просроченных платежах. Вы также можете настроить автоматические уведомления.",
            question6: "Можно ли экспортировать данные в другие системы?",
            answer6: "Да, Invoitio позволяет экспортировать счета в форматы PDF, Excel (.xlsx). В 2026 году будет подключен экспорт в XML и ISDOC для учетных систем, например Pohoda или Money S3.",
            question7: "Сколько языков поддерживает Invoitio?",
            answer7: "Invoitio поддерживает 6 языков: английский, чешский, словацкий, немецкий, русский и украинский. Вы можете создавать счета и использовать приложение на любом из этих языков.",
            answer7SignUp: "",
            answer7SignUpButton: "",
            answer7UserSettings: "",
            answer7UserSettingsButton: "",
            answer7Where: "",
            stillHaveQuestions: "Остались вопросы?",
        },
        cta: {
            title: "Начните бесплатно прямо сейчас",
            subtitle: "Создавайте счета-фактуры за 10 секунд и получайте финансовые отчеты мгновенно.",
            createAccount: "Создать аккаунт",
            viewDemo: "Посмотреть демо",
        },
        questions: {
            title: "Остались вопросы? С радостью ответим",
        },
        footer: {
            privacy: "Политика конфиденциальности",
            terms: "Условия",
            copyright: "© {year} Invoitio",
        },
        auth: {
            loginTitle: "Вход в аккаунт",
            resetTitle: "Восстановление пароля",
            resetDescription: "Укажите email, и мы отправим ссылку для сброса пароля.",
            email: "Email",
            password: "Пароль",
            signIn: "Войти",
            forgotPassword: "Забыли пароль?",
            sendResetLink: "Отправить ссылку",
            backToLogin: "Вернуться ко входу",
            rememberMe: "Запомнить меня",
            signUp: "Зарегистрироваться",
            noAccount: "Нет аккаунта?",
            alreadyHaveAccount: "Уже есть аккаунт?",
            passwordRequirements: "Пароль должен содержать минимум 8 символов, 1 строчную и 1 заглавную букву, и 1 цифру.",
            errors: {
                PASSWORD_TOO_SHORT: "Пароль должен содержать не менее 8 символов, как минимум 1 заглавную букву, 1 строчную букву и 1 цифру",
                PASSWORD_TOO_LONG: "Пароль должен содержать не более 128 символов, включая заглавные и строчные буквы, а также цифры",
                PASSWORD_MISSING_UPPERCASE: "Пароль должен содержать не менее 8 символов, как минимум 1 заглавную букву, 1 строчную букву и 1 цифру",
                PASSWORD_MISSING_LOWERCASE: "Пароль должен содержать не менее 8 символов, как минимум 1 заглавную букву, 1 строчную букву и 1 цифру",
                PASSWORD_MISSING_NUMBER: "Пароль должен содержать не менее 8 символов, как минимум 1 заглавную букву, 1 строчную букву и 1 цифру",
                PASSWORD_INVALID_TYPE: "Пароль должен быть строкой",
                EMAIL_REQUIRED: "Email обязателен",
                PASSWORD_REQUIRED: "Пароль обязателен",
                EMAIL_INVALID: "Неверный формат email",
                INVALID_CREDENTIALS: "Неверный email или пароль",
                USER_ALREADY_EXISTS: "Пользователь с таким email уже существует",
                AUTHENTICATION_REQUIRED: "Требуется аутентификация",
                TOKEN_INVALID: "Неверный или истекший токен",
                TOKEN_EXPIRED: "Токен истек",
                FAILED_TO_PROCESS: "Не удалось обработать запрос. Пожалуйста, попробуйте позже.",
                FAILED_TO_RESET: "Не удалось сбросить пароль. Пожалуйста, попробуйте позже.",
                RESET_LINK_SENT: "Если аккаунт с таким email существует, мы отправили инструкции по сбросу пароля.",
            },
        },
        registrationSuccess: {
            title: "Пожалуйста, подтвердите ваш email",
            myLanguage: "Мой язык:",
            languages: {
                cs: "🇨🇿 Чешский",
                en: "🇬🇧 Английский",
                ru: "Русский"
            },
            checkInboxBeforeEmail: "Пожалуйста, проверьте почту",
            checkInboxAfterEmail: "и перейдите по ссылке для активации аккаунта.",
            didntReceive: "Не получили письмо?",
            checkSpam: "Проверьте папку 'Спам'",
            makeSureCorrect: "Убедитесь, что email указан верно",
            waitMinutes: "Подождите несколько минут и попробуйте снова",
            continueToDashboard: "Перейти в панель управления"
        },
        verifyEmail: {
            verifying: "Подтверждение email...",
            wait: "Пожалуйста, подождите, пока мы подтверждаем ваш email.",
            verified: "Email подтвержден!",
            success: "Ваш email был успешно подтвержден!",
            alreadyVerified: "Ваш email уже подтвержден. Вы можете войти.",
            failed: "Ошибка подтверждения",
            noToken: "Токен подтверждения не предоставлен",
            goDashboard: "В панель управления",
            goLogin: "Войти",
            signUpAgain: "Зарегистрироваться снова"
        },
        resetPassword: {
            title: "Сброс пароля",
            newPassword: "Новый пароль",
            confirmPassword: "Подтвердите пароль",
            saveButton: "Сохранить новый пароль",
            resetting: "Сброс...",
            success: "Пароль изменен!",
            redirecting: "Перенаправление в панель управления...",
            invalidLink: "Неверная ссылка",
            invalidLinkDescription: "Эта ссылка для сброса пароля неверна или устарела.",
            backToLogin: "Перейти к логину",
            passwordsDoNotMatch: "Пароли не совпадают",
        },
        testimonials: {
            title: "Нам доверяют",
            subtitle: "Фрилансеры, студии и маленькие компании из 12 стран",
            testimonial1: {
                name: "Мария, дизайнер",
                text: "Сократила время на счета с 20 минут в день до 5.",
            },
            testimonial2: {
                name: "Студия Nord",
                text: "Перешли с конкурента: дешевле и гибче поля.",
            },
            testimonial3: {
                name: "Антон, dev-команда",
                text: "Платежи стали поступать на 30% быстрее.",
            },
        },
        testimonialsSection: {
            title: "Отзывы клиентов",
            testimonial1: {
                text: "Отправка счетов прямо из приложения экономит кучу времени. Возможность выставлять счета в любой валюте и на нужном языке — огромный плюс. Я очень доволен и простотой, и быстротой программы, а главное — её приятной по сравнению с конкурентами ценой и отсутствием лимитов на создание счетов. Ребята, спасибо! :)",
                name: "Josef",
                role: "предприниматель",
                img: "/josef.png",
            },
            testimonial2: {
                text: "Раньше я вела счета в Google таблицах - это было довольно неудобно. В Invoitio всё собрано в одном месте: счета, расходы, доходы и важные для стартапa метрики. Особенно классно иметь сводный отчёт в одной валюте и экспорт для бухгалтера - это сильно упростило мне жизнь и снизило бюджет на работу бухгалтера при подаче налоговой отчётности.",
                name: "Kateřina",
                role: "предпринимательница",
                img: "/katerina.png",
            },
        },
        team: {
            title: "Кто это создал?",
            members: {
                alice: {
                    name: "Алиса",
                    role: "Основательница",
                    bio: "{link}. Работала с такими именами, как Canva и Wargaming. Любит делать сложные вещи простыми.",
                    bioLinkText: "Старший инженер-программист с 6-летним стажем"
                },
                natalie: {
                    name: "Натали",
                    role: "Маркетинг специалист",
                    bio: "Она также химик (вау!). Любит делать из малого большое."
                },
                jana: {
                    name: "Яна А.",
                    role: "Инженер по ручному тестированию"
                },
                renata: {
                    name: "Рената Г.",
                    role: "Фронтенд-инженер и инженер по ручному тестированию"
                },
                simon: {
                    name: "Саймон Р.",
                    role: "Старший бэкенд-инженер — консультант"
                }
            }
        },
    },
    contact: {
        websiteBy: "сайт студии kiki-mori",
    },
    notFound: {
        title: "Страница не найдена",
        subtitle: "Возможно, страница удалена, перемещена или никогда не существовала.",
        cta: "Начать Invoitio бесплатно",
    },
    terms: {
        title: "Условия использования",
        sections: [
            {
                title: "1. Информация о поставщике",
                paragraphs: [
                    "SaaS-платформа Invoitio («Сервис») управляется следующим поставщиком:",
                    "Поставщик: Alisa Zakhtarenko, OSVČ",
                    "IČO: 21512302",
                    "Юридический адрес: Praha – Vinohrady, Mánesova 1080/3, 12000",
                    "Статус НДС: Неплательщик НДС (Neplátce DPH)",
                    "Контакт: support [at] invoitio [dot] com",
                    "Настоящие Условия регулируют использование Сервиса, предоставляемого Поставщиком.",
                ],
            },
            {
                title: "2. Описание Сервиса",
                paragraphs: [
                    "Сервис представляет собой онлайн-SaaS-платформу, доступную через учетную запись пользователя.",
                    "Пользователи получают доступ к функциональности Сервиса; права собственности на базовое программное обеспечение, код или контент не передаются.",
                    "Сервис лицензируется, а не продается.",
                ],
            },
            {
                title: "3. Регистрация и использование учетной записи",
                paragraphs: [
                    "Создавая учетную запись, пользователи соглашаются предоставлять точную и полную информацию.",
                    "Поставщик может ограничить, приостановить или прекратить доступ в случаях, включая:",
                ],
                list: [
                    "неправильное или оскорбительное поведение,",
                    "риски безопасности,",
                    "нарушение настоящих Условий.",
                ],
                paragraphsAfterList: [
                    "Пользователи соглашаются использовать Сервис ответственно и в соответствии с применимым законодательством.",
                ],
            },
            {
                title: "4. Ценообразование, платежи и выставление счетов",
                paragraphs: [
                    "Цены доступны на веб-сайте или внутри приложения.",
                    "Подписки оплачиваются в начале каждого расчетного периода.",
                    "Если платеж не может быть обработан, доступ может быть временно ограничен до решения проблемы.",
                    "Счета выставляются в электронном виде.",
                ],
            },
            {
                title: "5. Подписка и автопродление",
                paragraphs: [
                    "Подписки продлеваются автоматически в конце каждого расчетного периода.",
                    "Автопродление можно отключить в любое время в интерфейсе приложения.",
                    "Если у вас возникли трудности с оплатой или отменой, пожалуйста, свяжитесь с нами: support [at] invoitio [dot] com",
                ],
            },
            {
                title: "6. Политика возврата",
                paragraphs: [
                    "Возврат средств обычно не предлагается.",
                    "Однако, если технические проблемы со стороны Сервиса помешали пользователю отменить подписку или получить доступ к управлению оплатой, Поставщик может произвести возврат за затронутый расчетный период.",
                    "Возврат средств также может быть рассмотрен индивидуально в исключительных обстоятельствах.",
                ],
                subsections: [
                    {
                        title: "6.1 Политика отмены",
                        paragraphs: [
                            "Пользователи могут отменить свою подписку в любое время через интерфейс приложения.",
                            "Месячные подписки: Пользователи сохраняют доступ до конца текущего расчетного периода.",
                            "Все остальные типы подписок: Отмена следует той же политике, что и пожизненный доступ; доступ остается действительным только до тех пор, пока Сервис продолжает работу.",
                            "Отмена не приводит автоматически к возврату средств, если только технические проблемы (как определено выше) не помешали надлежащей отмене.",
                        ],
                    },
                ],
            },
            {
                title: "7. Пожизненный доступ (Lifetime Access)",
                paragraphs: [
                    "Если Сервис предлагает вариант «пожизненного доступа», это относится к доступу в течение срока эксплуатации Сервиса, а не жизни пользователя.",
                    "Если работа Сервиса или бизнес будут прекращены, станут нерентабельными, юридически невозможными для эксплуатации или иным образом прекратятся, все формы доступа — включая пожизненный доступ — будут прекращены.",
                    "Никакие возвраты или дальнейшие обязательства не применяются сверх срока эксплуатации Сервиса.",
                    "Месячные подписчики всегда сохраняют доступ до конца своего расчетного периода, даже если Сервис планируется закрыть.",
                    "Все остальные типы подписок следуют тем же правилам, что и пожизненный доступ.",
                ],
            },
            {
                title: "8. Интеллектуальная собственность",
                paragraphs: [
                    "Все программное обеспечение, исходный код, дизайн, брендинг, название Invoitio и весь связанный контент являются исключительной интеллектуальной собственностью Поставщика.",
                    "Пользователи получают ограниченную, неисключительную, непередаваемую лицензию на использование Сервиса только по его прямому назначению.",
                    "Следующие действия строго запрещены:",
                ],
                list: [
                    "копирование или воспроизведение Сервиса или любой его части,",
                    "модификация, адаптация, перевод или создание производных работ,",
                    "обратная разработка, декомпиляция или попытка извлечения исходного кода,",
                    "неправомерное использование названия, логотипа, брендинга или элементов дизайна Invoitio в собственных продуктах пользователя,",
                    "распространение, перепродажа, сублицензирование или предоставление доступа к Сервису третьим лицам без явного разрешения Поставщика.",
                ],
                subsections: [
                    {
                        title: "Разрешенное использование",
                        paragraphs: [
                            "Пользователи могут ссылаться на Сервис или упоминать его (включая название «Invoitio») в СМИ, обзорах, постах в социальных сетях, статьях или информационных контекстах, если такое использование не подразумевает право собственности на Сервис.",
                        ],
                    },
                ],
            },
            {
                title: "9. Ограничение ответственности",
                paragraphs: [
                    "Сервис предоставляется «как есть», и прилагаются разумные усилия для обеспечения стабильности и доступности.",
                    "Поставщик не несет ответственности за:",
                ],
                list: [
                    "потерю данных,",
                    "перерывы в работе или сбои в обслуживании,",
                    "косвенные, случайные или последующие убытки.",
                ],
                paragraphsAfterList: [
                    "Общая ответственность Поставщика ограничена суммой, уплаченной пользователем в течение последних шести (6) месяцев использования.",
                ],
            },
            {
                title: "10. Персональные данные и соблюдение GDPR",
                paragraphs: [
                    "Поставщик обрабатывает персональные данные в соответствии с GDPR и чешским законодательством о защите персональных данных. Подробности описаны в Политике конфиденциальности.",
                ],
            },
            {
                title: "11. Доступность Сервиса и обновления",
                paragraphs: [
                    "Могут возникать временные периоды технического обслуживания или кратковременные перерывы.",
                    "Поставщик может обновлять, изменять или улучшать Сервис в любое время для повышения функциональности, безопасности или производительности.",
                ],
            },
            {
                title: "12. Прекращение действия и удаление данных",
                paragraphs: [
                    "Учетные записи могут быть закрыты:",
                ],
                list: [
                    "по запросу пользователя,",
                    "из-за длительного отсутствия активности,",
                    "в случаях злоупотребления или нарушения Условий,",
                    "когда это требуется по закону.",
                ],
                paragraphsAfterList: [
                    "После прекращения действия данные пользователя могут быть удалены в соответствии с законодательными и внутренними требованиями к хранению данных.",
                ],
            },
            {
                title: "13. Применимое право",
                paragraphs: [
                    "Настоящие Условия регулируются законодательством Чешской Республики.",
                    "Любые споры подлежат разрешению в компетентных судах Чешской Республики.",
                ],
            },
        ],
    },
    privacy: {
        title: "Политика конфиденциальности",
        sections: [
            {
                title: "1. Введение",
                paragraphs: [
                    "Настоящая Политика конфиденциальности объясняет, как Alisa Zakhtarenko, OSVČ («Поставщик») обрабатывает персональные данные пользователей SaaS-платформы Invoitio («Сервис») в соответствии с GDPR и применимыми законами Чехии о защите данных.",
                    "Используя Сервис, вы подтверждаете, что прочитали и поняли настоящую Политику.",
                ],
            },
            {
                title: "2. Контактная информация контролера данных",
                paragraphs: [
                    "Контролер данных:",
                    "Alisa Zakhtarenko, OSVČ",
                    "IČO: 21512302",
                    "Адрес: Praha – Vinohrady, Mánesova 1080/3, 12000",
                    "Email: support [at] invoitio [dot] com",
                ],
            },
            {
                title: "3. Персональные данные, которые мы обрабатываем",
                paragraphs: [
                    "Поставщик обрабатывает только те данные, которые необходимы для работы Сервиса.",
                ],
                subsections: [
                    {
                        title: "3.1 Данные, предоставляемые пользователем",
                        list: [
                            "адрес электронной почты",
                            "имя (если предоставлено)",
                            "учетные данные для входа",
                            "информация, связанная с платежами (обрабатывается через платежные системы; Поставщик не получает номера карт)",
                        ],
                    },
                    {
                        title: "3.2 Автоматически собираемые данные",
                        list: [
                            "IP-адрес",
                            "информация об устройстве и браузере",
                            "логи использования",
                            "диагностические и технические данные",
                        ],
                    },
                    {
                        title: "3.3 Платежные данные",
                        list: [
                            "ID транзакций",
                            "тип подписки",
                            "история платежей",
                        ],
                    },
                ],
            },
            {
                title: "4. Цели обработки",
                paragraphs: [
                    "Персональные данные обрабатываются для:",
                ],
                list: [
                    "предоставления и эксплуатации Сервиса",
                    "управления учетными записями пользователей",
                    "обработки платежей и выставления счетов",
                    "поддержки клиентов и связи",
                    "обеспечения безопасности и предотвращения злоупотреблений",
                    "выполнения юридических обязательств (налоговых и бухгалтерских)",
                ],
            },
            {
                title: "5. Правовые основы обработки",
                paragraphs: [
                    "Обработка основана на:",
                ],
                list: [
                    "исполнении договора (ст. 6(1)(b) GDPR) — предоставление Сервиса",
                    "законном интересе — улучшение безопасности и функциональности",
                    "юридическом обязательстве — бухгалтерский учет, налоговая отчетность",
                    "согласии пользователя, где это требуется (например, дополнительные куки)",
                ],
            },
            {
                title: "6. Передача персональных данных",
                paragraphs: [
                    "Данные могут передаваться только следующим лицам:",
                ],
                list: [
                    "платежные системы (например, Stripe, PayPal)",
                    "провайдеры хостинга и инфраструктуры",
                    "поставщики бухгалтерских или налоговых услуг",
                    "государственные органы, если это требуется по закону",
                ],
                paragraphsAfterList: [
                    "Поставщик не продает персональные данные третьим лицам.",
                ],
            },
            {
                title: "7. Хранение данных",
                paragraphs: [
                    "Персональные данные хранятся только до тех пор, пока это необходимо для:",
                ],
                list: [
                    "предоставления Сервиса,",
                    "выполнения юридических обязательств,",
                    "или пока пользователь не запросит удаление.",
                ],
                paragraphsAfterList: [
                    "Платежные и бухгалтерские записи должны храниться в соответствии с чешским законодательством (обычно 5–10 лет).",
                ],
            },
            {
                title: "8. Права пользователя в соответствии с GDPR",
                paragraphs: [
                    "Пользователи имеют право на:",
                ],
                list: [
                    "доступ к своим персональным данным",
                    "исправление",
                    "удаление («право на забвение»)",
                    "ограничение обработки",
                    "переносимость данных",
                    "возражение против обработки",
                    "подачу жалобы в Чешское управление по защите данных (ÚOOÚ)",
                ],
            },
            {
                title: "9. Безопасность данных",
                paragraphs: [
                    "Поставщик использует соответствующие технические и организационные меры защиты, включая:",
                ],
                list: [
                    "шифрование",
                    "безопасную передачу данных",
                    "ограничение доступа",
                    "регулярные обновления и мониторинг безопасности",
                ],
            },
            {
                title: "10. Международная передача данных",
                paragraphs: [
                    "Данные могут обрабатываться внутри или за пределами ЕС.",
                    "Передача за пределы ЕС происходит только в том случае, если принимающая сторона соответствует требованиям GDPR (например, SCC).",
                ],
            },
            {
                title: "11. Куки (Cookies)",
                paragraphs: [
                    "Сервис может использовать обязательные куки для обеспечения аутентификации и функциональности.",
                    "Дополнительные аналитические или маркетинговые куки используются только с согласия пользователя.",
                ],
            },
            {
                title: "12. Изменения в настоящей Политике",
                paragraphs: [
                    "Поставщик может обновлять настоящую Политику.",
                    "Любые изменения будут опубликованы на веб-сайте.",
                    "Продолжение использования Сервиса означает принятие обновленной Политики.",
                ],
            },
            {
                title: "13. Контакты для запросов по GDPR",
                paragraphs: [
                    "По любым вопросам или запросам относительно персональных данных, пожалуйста, свяжитесь с нами:",
                    "support [at] invoitio [dot] com",
                ],
            },
        ],
    },
    userSettings: {
        title: "Настройки пользователя",
        general: {
            title: "Общие настройки",
            defaultLanguage: "Язык приложения по умолчанию",
            defaultLanguageDescription: "Этот язык будет использоваться по умолчанию при входе в систему.",
            notificationEmail: "Адрес имейла для уведомлений клиентам по платежам",
            notificationEmailHandle: "Хендл имейла",
            notificationEmailName: "Имя отправителя",
            notificationEmailPreview: "Так будет выглядеть ваш адрес:",
            notificationEmailHandleErrorTaken: "Этот адрес уже занят другим пользователем",
            notificationEmailHandleErrorForbidden: "Этот адрес зарезервирован и не может быть использован",
        },
        changePassword: {
            title: "Изменить пароль",
            button: "Изменить пароль",
            resetLinkSent: "Инструкции по сбросу пароля отправлены на вашу почту.",
        },
        subscription: {
            title: "Подписка",
        },
        subscriptionUi: {
            mostPopular: "ВЫБИРАЮТ ЧАЩЕ ВСЕГО",
            bestDeal: "ЛУЧШЕЕ ПРЕДЛОЖЕНИЕ",
            monthly: "МЕСЯЧНАЯ",
            yearly: "ГОДОВАЯ",
            perMonth: "/ месяц",
            perYear: "/ год",
            subscribe: "Оформить",
            cancel: "Отменить подписку",
            lifetime: "ПОЖИЗНЕННЫЙ",
            planLabel: "ТАРИФ",
        },
        subscriptionDetails: {
            status: "Статус",
            renewsAt: "Продление",
            accessUntil: "Доступ до",
            notSubscribed: "Нет подписки",
            canceled: "Отменена",
            resubscribeTitle: "Продлите подписку, чтобы сохранить доступ",
            resubscribeSubtitle: "Выберите тариф ниже, чтобы продолжить использование после окончания текущего периода.",
        },
        paymentMessage: {
            success: "Спасибо за оплату! Ваша подписка активна.",
            cancelled: "Оплата отменена. Если это ошибка — попробуйте снова.",
        },
        paymentSuccess: {
            title: "Оплата прошла успешно! 🎉",
            subtitle: "Мы очень рады, что можем помочь вашему бизнесу🙏🏻",
            button: "Продолжить",
            team: "Команда Invoitio"
        },
        emailTransferNotice: "Если вам нужно изменить email и перенести подписку на другой аккаунт, напишите нам на support@invoitio.com",
        deleteAccountNotice: "Если вы хотите удалить свой аккаунт, напишите нам с имейла, на который был зарегистрирован аккаунт на support@invoitio.com",
        trial: {
            title: "Ваш пробный период",
            subtitle: "Ваш пробный период закончится через {days} {daysLabel}",
            subscribe: "Оформить подписку со скидкой 15% до {date}",
            description: "Получите неограниченный доступ ко всем функциям и профессиональным шаблонам.",
            remainingDays: "Дней осталось",
            barAction: "Ваш пробный период закончится через {days} {daysLabel}",
            barActionLead: "Оформите подписку сейчас",
            thanks: "❤️ Спасибо, что выбираете нас",
        },
        trialExpired: {
            title: "Ваш пробный период истек!",
            description: "Оформите подписку в Invoitio, чтобы продолжать пользоваться нашим сервисом.",
            monthly: "Месячная",
            yearly: "Годовая",
            periodMonth: "/ месяц",
            periodYear: "/ год",
            lifetimeOffer: "Не хотите платить подписку? Получите пожизненный доступ к Invoitio за {price}. Предложение ограничено. У вас осталось {timer}.",
            lifetimeAccess: "Полная окупаемость сервиса за 1,5 года — получите пожизненный доступ за",
            lifetimeLimited: "Предложение ограничено.",
            buyNow: "Получить пожизненный доступ",
            subscribe: "Оформить",
            thanks: "Спасибо, что выбираете нас",
            downloadPreviousInvoices: "Скачать ранее сделанные счета",
            downloadExpensesTable: "Скачать таблицу с расходами",
        },
        affiliate: {
            title: "Партнерская программа",
            referredUsersTitle: "Привлеченные пользователи",
            description: "Получайте 30% комиссии с платежей всех пользователей, которых вы приведёте. Пожизненно.",
            yourReferralCode: "Ваш реферальный код",
            copy: "Копировать",
            copied: "Скопировано",
            table: {
                email: "Email",
                signupDate: "Дата регистрации",
                status: "Статус",
                active: "Активен",
                trial: "Триал",
                inactive: "Неактивен",
            },
            bankInfo: {
                title: "Банковские реквизиты для выплат",
                description: "Введите ваши банковские реквизиты, на которые вы хотите получать комиссионные отчисления.",
                accountNumber: "Номер счета",
                iban: "IBAN",
                bic: "BIC",
                swift: "SWIFT",
                bankName: "Название банка",
                bankAddress: "Адрес банка",
                fullName: "Имя и фамилия",
                save: "Сохранить реквизиты",
                saved: "Реквизиты успешно сохранены",
                errorRequired: "Пожалуйста, введите номер счета или IBAN.",
            }
        },
    },
    // Blog
    blog: {
        title: "Блог",
        post1: {
            title: "Invoitio vs Fakturoid, iDoklad и FakturyWeb: что выбрать для счетов в Чехии",
            intro: "Если вы ищете сервис выставления счетов в Чехии, почти всегда всплывают три названия: Fakturoid, iDoklad и FakturyWeb. Они знакомы бухгалтерам, работают давно и закрывают базовые задачи. Invoitio появился позже — и изначально делался с другим фокусом: не просто «выписать счёт», а упростить жизнь фрилансерам, малому бизнесу и бухгалтерам одновременно. Ниже — честное сравнение без рекламных лозунгов.",
            comparisonTitle: "Краткое сравнение",
            table: {
                feature: "Функция",
                languages: "Языки интерфейса",
                currencies: "Валюты",
                rates: "Курсы валют (ECB)",
                analytics: "Аналитика (MRR, ARPU, LTV)",
                multiProfit: "Мультивалютная прибыль",
                accountingAccess: "Доступ для бухгалтера",
                export: "Экспорт документов",
                lifetime: "Пожизненный доступ",
                speed: "Скорость создания счёта",
                yes: "Да",
                no: "Нет",
                limited: "Ограниченно",
                partial: "Частично",
                average: "Средне",
                faster: "Медленнее",
                seconds: "≈ 10 секунд"
            },
            focusTitle: "Invoitio — когда важен не только счёт, но и понимание бизнеса",
            focusText: "Invoitio делался не как «ещё одна фактура», а как рабочий инструмент для тех, кто работает с клиентами из разных стран, получает доход в разных валютах и хочет понимать, сколько и на чём зарабатывает, а не просто хранить счета. Сервис одинаково удобен фрилансерам, малому бизнесу и бухгалтерам, которые ведут клиентов.",
            featuresTitle: "Что в Invoitio реально удобно",
            feature1Title: "Языки без компромиссов",
            feature1Text: "Интерфейс и сами счета доступны на пяти языках: чешский, английский, немецкий, русский, словацкий. Это редкость для чешских сервисов и большой плюс, если клиенты не только из CZ.",
            feature2Title: "Простое и сильное UI",
            feature2Text: "Интерфейс спроектирован так, чтобы не мешать работе. Минимум экранов, логичный флоу, ничего лишнего. По скорости и удобству Invoitio выигрывает у большинства конкурентов — счёт реально делается за секунды.",
            feature3Title: "Любые валюты + нормальный пересчёт",
            feature3Text: "Доход можно считать в одной базовой валюте, даже если клиенты платят в разных. Курсы автоматически подтягиваются из Европейского центрального банка (ECB). Из сравниваемых сервисов это есть только у Invoitio и iDoklad.",
            feature4Title: "Аналитика, а не просто список счетов",
            feature4Text: "MRR, ARPU, LTV, доходы по клиентам и валютам — без Excel и ручных подсчётов.",
            feature5Title: "Отдельный доступ для бухгалтера",
            feature5Text: "Без передачи логина и пароля. Доступ включён в цену — это важно, если с бухгалтером работаете постоянно.",
            feature6Title: "Оплата без ловушек",
            feature6Text: "Можно выбрать подписку, а можно купить пожизненный доступ одним платежом и забыть о счетах за сервис.",
            fakturoidTitle: "Fakturoid — надёжно, но консервативно",
            fakturoidText: "Fakturoid отлично подходит для локального бизнеса в Чехии. Он стабильный, понятный и привычный бухгалтерам. Но: почти нет аналитики, слабая работа с валютами, не очень подходит для фрилансеров и международной работы. Хороший вариант, если у вас всё в CZK и без планов на рост.",
            idokladTitle: "iDoklad — для бухгалтерии в первую очередь",
            idokladText: "iDoklad удобен, когда бухгалтер — главный пользователь. Он хорошо справляется с учётом и налогами. Минусы: интерфейс перегружен, аналитика ограничена, не самый быстрый для ежедневной работы фрилансера.",
            fakturywebTitle: "FakturyWeb — самый простой вариант",
            fakturywebText: "Подойдёт, если нужно просто выставить счёт и ничего больше. Но: почти нет автоматизации, нет аналитики, слабые возможности роста.",
            conclusionTitle: "Кому Invoitio подойдёт лучше всего",
            conclusionText: "Invoitio — хороший выбор, если вы: фрилансер с иностранными клиентами, владелец малого бизнеса, бухгалтер, ведущий несколько клиентов, работаете в разных валютах, хотите простой интерфейс и контроль над доходами, не хотите вечно сидеть на подписке."
        },
        post2: {
            title: "Как выставить счет в Чехии как OSVČ (ИП)?",
            intro: "Вы начинаете бизнес как индивидуальный предприниматель и думаете, как правильно выставить свой первый счет? Независимо от того, являетесь ли вы плательщиком НДС или нет, существуют правила, которые необходимо соблюдать. В этом руководстве мы расскажем вам обо всем: от обязательных данных до момента, когда вы можете стать плательщиком НДС.",
            ctaTitle: "Образец счета для неплательщика НДС (скачать)",
            ctaText: "Вы можете сгенерировать счет онлайн прямо сейчас — в нашем бесплатном генераторе счетов. Вы справитесь менее чем за минуту после регистрации.",
            q1Title: "Когда я должен выставить счет как OSVČ?",
            q1Text: "Для неплательщика НДС (OSVČ или фирма с оборотом до 2 млн крон) законом не установлен точный срок выставления счета, в отличие от плательщиков НДС, но рекомендуется сделать это как можно скорее после поставки товара или услуги.",
            q2Title: "Когда вы становитесь плательщиком НДС?",
            q2Text: "Вы становитесь плательщиком НДС в следующих случаях:",
            q2List: [
                "с 1 января следующего года, если ваш оборот за предыдущий календарный год превысит 2 000 000 крон,",
                "на следующий день после превышения оборота в 2 536 500 крон в течение календарного года,",
                "если вы наследуете экономическую деятельность от лица, которое было плательщиком НДС,",
                "или если вы принимаете предприятие или имущество в рамках приватизации, слияния или разделения компании."
            ],
            q2Note: "Если вы только начинаете бизнес, вы, скорее всего, не являетесь плательщиком НДС. В таком случае для вас действуют более простые правила.",
            section1Title: "Счета для неплательщиков НДС с налоговым учетом (daňová evidence)",
            section1Text: "Требования к счету основываются на Гражданском кодексе, в частности на законе № 89/2012 Св.",
            section1MandatoryTitle: "Обязательные данные в счете:",
            section1MandatoryList: [
                "имя и фамилия (для OSVČ) или название компании,",
                "юридический адрес фирмы или OSVČ,",
                "данные о регистрации в реестре (торговый реестр, включая раздел и вкладыш, или предпринимательский реестр),",
                "IČO (идентификационный номер)."
            ],
            section1MandatoryNote: "С точки зрения закона никаких других обязательных данных не требуется.",
            section1OptionalTitle: "Необязательные, но обычно указываемые данные:",
            section1OptionalList: [
                "информация о покупателе (обычно в том же объеме, что и у поставщика – имя/название, адрес, IČO),",
                "числовое и словесное обозначение документа (например, FV-2025-001),",
                "описание поставленного товара или оказанной услуги,",
                "сумма к оплате (общая или расписанная по единицам и количеству),",
                "дата выставления счета."
            ],
            q3Title: "А как насчет срока оплаты?",
            q3Text: "Закон устанавливает базовый срок оплаты в 30 дней (который одновременно является и максимальным сроком), однако с клиентом можно договориться и о другом сроке оплаты.",
            edgeCaseTitle: "Особый случай: Счет неплательщика НДС при ведении бухгалтерского учета (účetnictví)",
            edgeCaseText: "Бухгалтерский учет обязаны вести все юридические лица, независимо от уровня их доходов. Если у вас есть обязанность вести бухучет (например, как юридическое лицо) или вы решили делать это добровольно (например, OSVČ вместо налогового учета), требования к счету регулируются законом № 563/1991 Св. о бухгалтерском учете.",
            edgeCaseMandatoryTitle: "Счет неплательщика НДС в бухучете содержит те же основные данные, что и при налоговом учете, но дополнительно должен включать:",
            edgeCaseMandatoryList: [
                "описание товара или услуги,",
                "выставленную сумму (общую или расписанную по единицам и количеству),",
                "дату выставления документа,",
                "данные о записи в государственном реестре (включая раздел и вкладыш)."
            ],
            finalCtaTitle: "Попробуйте Invoitio бесплатно",
            finalCtaText: "Генерируйте счета за считанные секунды и следите за тем, когда вы приближаетесь к порогу обязательной регистрации плательщиком НДС — без ручного подсчета и без стресса."
        }
    },

    // Time Tracking
    timeTracking: {
        title: "Тайм-трекинг",
        newProject: "Новый проект",
        projectName: "Название проекта",
        createProject: "Создать проект",
        noProjects: "Проектов пока нет. Создайте свой первый проект, чтобы начать отслеживать время.",
        addService: "Добавить задачу или услугу",
        serviceName: "Название услуги",
        hourlyRate: "Почасовая ставка",
        dailyRate: "Дневная ставка",
        fixedPrice: "Фиксированная цена",
        rate: "Цена",
        totalTime: "Общее время",
        totalAmount: "Общая цена",
        billed: "Счет выставлен",
        notBilled: "Счет не выставлен",
        generateInvoice: "Выставить счет",
        selectItems: "Выберите пункты для счета",
        timerRunning: "Таймер запущен",
        timerPaused: "Таймер остановлен",
        units: {
            hourly: "/ час",
            daily: "/ день",
            fixed: "фикс"
        },
        deleteModal: {
            titleProject: "Удалить проект",
            messageProject: "Вы уверены, что хотите удалить этот проект? Все связанные задачи и записи времени будут безвозвратно удалены.",
            titleTask: "Удалить задачу",
            messageTask: "Вы уверены, что хотите удалить эту задачу? Это действие нельзя отменить.",
            confirm: "Удалить",
            cancel: "Отмена"
        }
    },
};
